<div class="modal-layer" [ngClass]="{ 'active':modal.open }">
    <div class="backdrop"></div>

    <div class="alert" *ngIf="modal.cntx == 'adding-protocol'">
        <div class="loader">
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
        </div>
        <span class="loader-text">Добавяне на протокол...</span>
    </div>
</div>

<div class="content no-subheader">
    <span class="page-title">
        Нов протокол 
        <span class="right-btn" (click)="AddProtocol()">Добавяне</span>
        <span routerLink="/fuji-service-presale" class="right-btn negative">Отказ</span>
    </span>

    <div class="tab-holder">
        <div class="tab-headers">
            <div class="tab-header" (click)="switchTab('general')" [ngClass]="{ 'active':tab == 'general' }">Основна информация</div>
        </div>
        <div class="tab-content">
            <div class="tab" *ngIf="tab == 'general'">
                <div class="category-title">Основна информация</div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Номер на протокол</span>
                    <input type="text" disabled placeholder="Въведете наименование"  [(ngModel)]="addProtocol.service_num" />
                </div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Име на представител на ТЕМПЕКС</span>
                    <input type="text" placeholder="Въведете име на представител"  [(ngModel)]="addProtocol.seller_name" />
                </div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Име на дилър</span>
                    <input type="text" placeholder="Въведете име на търговец"  [(ngModel)]="addProtocol.dealer_name" />
                </div>
                <div class="category-title">Информация за продукт</div>
                <table class="ac_list">
                    <thead>
                        <tr>
                            <th>Модел (Външно тяло)</th>
                            <th>Сериен номер (Външно тяло)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ac of ac_list;let i = index">
                            <td><input (input)="changeAcRow(ac, i)" type="text" [(ngModel)]="ac.model" /></td>
                            <td><input (input)="changeAcRow(ac, i)" type="text" [(ngModel)]="ac.serial" /></td>
                        </tr>
                    </tbody>
                </table>
                <!-- <div class="col-xl-6 col-lg-6 input-row">
                    <span class="label">Модел (Външно тяло)</span>
                    <input type="text" placeholder="Въведете наименование"  [(ngModel)]="addProtocol.model_outdoor" />
                </div>
                <div class="col-xl-6 col-lg-6 input-row">
                    <span class="label">Сериен номер  (Външно тяло)</span>
                    <input type="text" placeholder="Въведете наименование"  [(ngModel)]="addProtocol.serial_outdoor" />
                </div> -->
                <!-- <div class="col-xl-12 col-lg-12 input-row">
                    <span class="label">Описание на дефекта / оплакване</span>
                    <textarea  [(ngModel)]="addProtocol.description"></textarea>
                </div> -->
            </div>
        </div>
    </div>
</div>